<template>
   <div>
    <div class="transaction-explorer mt-14 mb-14">
      <div class="mb-[10px]">
        <Paragraph class="text-blue-dark font-jost-regular text-[25px]" text="Authority Account" />
        <div class="flex gap-[20px] max-w-max relative w-auto">
          <p class="text-blue-light break-all font-jost-regular w-full text-blue-light text-left" style="font-size: 25px">
            {{ publicAddress }}
            <span class="inline-block cursor-pointer" title="Copy hash">
              <CopyIcon :isActive="checkIfIsEqual(publicAddress)" @click="copy(publicAddress)" title="Copy hash"
                class="h-[33px] ml-2 inline-block cursor-pointer" />
            </span>
          </p>
        </div>
      </div>

      <section class="t-results justify-between text-lg mt-5 mt-[105px] flex">
        <div>
          <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mb-[11px]" text="Overview" />

          <div v-if="loaders.accountDetails"
            class="overview__section bg-white rounded-[9px] flex justify-center w-full mt-[30px] w-[676px] h-[250px] items-center">
            <Loader color="#64748B" width="30px" height="30px" />
          </div>
          <section v-else class="overview__section w-[676px] flex flex-wrap gap-[100px] mb-[60px]">
            <div v-if="!loaders.accountDetails && account && Object.keys(account).length"
              class="t-results-body bg-white w-full">
              <div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Admin User
                  </div>
                  <div class="col hash-value-col font-jost-regular px-2.5 text-blue-dark flex items-center gap-[10px]">
                    <span
                      v-if="account.adminUser"
                      class="block text-ellipsis text-[16px]"
                    >
                      {{ getLongHashText(account.adminUser) || 'N/A' }}
                    </span>
                    <span v-else class="block text-ellipsis text-[16px]">
                      N/A
                    </span>
                    <CopyIcon
                      v-if="account.adminUser"
                      :isActive="checkIfIsEqual(account.adminUser, 'adminUser')"
                      @click="copy(account.adminUser, 'adminUser')"
                      title="Copy hash"
                      class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top"
                    />
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Nonce
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.nonce || 'N/A' }}
                    </span>
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    COIN Balance
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ getBalance(account.amount) }} GEEQ
                    </span>
                  </div>
                </div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Chain Number
                  </div>
                  <router-link
                    v-if="account && account.chainNumber"
                    class="col px-2.5 text-blue-light cursor-pointer text-[16px]"
                    :to="{ name: 'chain', params: { chainNumber: account.chainNumber } }"
                  >
                    #{{ account.chainNumber }}
                  </router-link>
                  <div v-else class="col px-2.5">
                    N/A
                  </div>
                </div>
                
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Account Number
                  </div>
                  <div class="col hash-value-col font-jost-regular px-2.5 text-blue-dark flex items-center gap-[10px]">
                    <span class="block text-ellipsis text-[16px]">
                      {{ getLongHashText(account.accountNumVal) || 'N/A' }}
                    </span>
                    <CopyIcon
                      v-if="account.accountNumVal"
                      :isActive="checkIfIsEqual(account.accountNumVal, 'accountNumVal')"
                      @click="copy(account.accountNumVal, 'accountNumVal')"
                      title="Copy hash"
                      class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top"
                    />
                  </div>
                </div>
                <!-- <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Created At
                  </div>

                  <div class="font-jost-regular px-2.5 text-blue-dark">
                    <router-link v-if="account && account.blockNumber" class="block flex relative cursor-pointer"
                      :to="{ name: 'block', params: { chainNumber: account.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: account.blockNumber } }">
                      Block #{{ account.blockNumber }}
                    </router-link>
                    {{ getTxCreationDateUtc() }} UTC
                  </div>
                </div> -->
              </div>
            </div>
            <Paragraph text="We couldn't find any results.." class="text-blue-dark text-lg mt-5 float-left" v-else />
          </section>
        </div>
        <OwnedNftsPanel :account-address="publicAddress" :chain-number="chainNumber" />
      </section>
      <div>
        <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] mt-[82px] mb-[10px]"
          text="Transactions" />
        <div v-if="loaders.transactions" class="flex items-center justify-center py-6">
          <Loader color="#64748B" width="30px" height="30px" />
        </div>
        <template v-else>
          <SearchableTable
            :transactions="proxyNftMintTransactions || []"
            :copied="copied"
            :initialFilters="searchableTableInitialFilters"
            :accountAddress="publicAddress"
            @copied="handleCopied"
            @filtersChanged="handleFiltersChanged"
          />
          <div class="flex justify-end px-[25px]">
            <pagination-component :items="proxyNftMintTransactions.totalCount || 0" :initialPage="getInitialPage()"
              @changePage="setFoundResult" class="float-left" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";

import api from '@/helpers/api';
import string from '@/helpers/string';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

import Paragraph from "@/components/web/ParagraphComponent";
import SearchableTable from '@/components/common/SearchableTable.vue';
import OwnedNftsPanel from '@/components/web/OwnedNftsPanel.vue';

import PaginationComponent from '@/components/common/PaginationComponent.vue';
import { maxTableRows } from "@/utils/pagination";
import moment from 'moment';

const TRANSACTION_TYPE_VALUES = ['attestCommit', 'coin', 'proxyCreate', 'nftMint'];

export default {
  name: "ProxyNftMintAccountComponent",
  components: {
    CopyIcon,
    Loader,
    Paragraph,
    SearchableTable,
    PaginationComponent,
    OwnedNftsPanel
  },
  props: {
    walletAddress: {
    },
    publicAddress: {
      required: true
    },
  },
  computed: {
    chainNumber() {
      return this.$route.params.chainNumber ? parseInt(this.$route.params.chainNumber, 10) : undefined;
    },
    routeName() {
      return this.$route.name
    },
    searchableTableInitialFilters() {
      return {
        from: this.publicAddress || '',
        to: this.publicAddress || '',
      };
    },
  },
  data: () => {
    return {
      proxyNftMintTransactions: {
        totalCount: 0,
        items: []
      },
      loaders: {
        accountDetails: true,
        nfts: true,
        transactions: false,
        nftTransactions: false,
      },
      account: null,
      copied: '',
      initialPage: 1,
      pageSize: maxTableRows,
      transactionFilters: {
        from: '',
        to: '',
        type: [...TRANSACTION_TYPE_VALUES],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: ['valid', 'invalid'],
      },
      balanceDivisor: parseInt(process.env.VUE_APP_BALANCE_DIVISOR, 10) || 1000000000,
      transactionRefHash: "",
      currentShowingNftHash: "",
      virtualFlag: false,   // vue-json-pretty setting
      showLine: true,
      lastPath: null,
      collapsedOnClickBrackets: true,
      stackTxsDetails: null,
      currentScrollItem: 1,
      transactionData: {},
      nfts: [],
      placeholderImg: "/images/placeholder.jpg",
      uatOrderedSample: {
        "uatData": null,
        "signature": null,
      },
      uatDataOrderedSample: {
        "groupType": null,
        "blockNumber": null,
        "chainNumber": null,
        "userPublicKey": null,
        "payloadRefHash": null,
      },
    }
  },

  created() {
    this.lastPath = this.$router.options.history.state.back;
    this.searchByAccPublicAddress(this.walletAddress);
    this.initializeTransactionFilters();
    this.fetchTransactions(0);
    // this.getAccountNfts(this.publicAddress, 99000, 0);
  },
  mounted() {
    this.currentShowingNftHash = this.$route.query.hash;
  },
  methods: {
    getBalance(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return amount;
      }

      const parsedAmount = Number(amount);

      if (Number.isNaN(parsedAmount) || !this.balanceDivisor) {
        return amount;
      }

      return parsedAmount / this.balanceDivisor;
    },
    setCopied(hash) {
      this.copied = hash;
    },
     getLongHashText(str) {
       if (!str) {
         return '';
       }

       if (str.length <= 28) {
         return str;
       }

       return `${str.slice(0, 12)}...${str.slice(-12)}`;
     },
    getShortenedText(str) {
      return string.getShortenHash(str)
    },
    initializeTransactionFilters() {
      this.transactionFilters = {
        from: this.publicAddress,
        to: this.publicAddress,
        type: [...TRANSACTION_TYPE_VALUES],
        minBlock: undefined,
        maxBlock: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: ['valid', 'invalid'],
      };
    },
    fetchTransactions(skip = 0) {
      this.loaders.transactions = true;

      const params = {
        chainNumber: this.chainNumber ? parseInt(this.chainNumber, 10) : undefined,
        from: this.transactionFilters.from,
        to: this.transactionFilters.to,
        type: this.transactionFilters.type,
        minBlock: this.transactionFilters.minBlock,
        maxBlock: this.transactionFilters.maxBlock,
        dateFrom: this.transactionFilters.dateFrom,
        dateTo: this.transactionFilters.dateTo,
        status: this.transactionFilters.status,
        limit: maxTableRows,
        skip,
      };

      api.getTransactionsByType(params)
        .then((res) => {
          this.proxyNftMintTransactions = {
            ...res.data,
            skip,
          };
          this.loaders.transactions = false;
        })
        .catch(() => {
          this.loaders.transactions = false;
        });
    },
    getTxCreationDateUtc() {
      const createdAt = this.account.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment.utc(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    getItem(page) {
      const normalizedPage = Number(page) > 0 ? Number(page) : 1;
      const skip = (normalizedPage - 1) * maxTableRows;
      this.fetchTransactions(skip);
    },
    setFoundResult(data) {
      const page = Number(data?.page) > 0 ? Number(data.page) : 1;
      this.getItem(page);
    },
    getInitialPage() {
      const skip = this.proxyNftMintTransactions?.skip
        ?? this.proxyNftMintTransactions?.meta?.skip
        ?? 0;
      return Math.floor(skip / this.pageSize) + 1;
    },
    handleCopied(copiedText) {
      this.copied = copiedText;
    },
    handleFiltersChanged(filterData) {
      const fromAddress = typeof filterData.from === 'string' && filterData.from.trim()
        ? filterData.from.trim()
        : undefined;
      const toAddress = typeof filterData.to === 'string' && filterData.to.trim()
        ? filterData.to.trim()
        : undefined;

      const nextFilters = {
        from: fromAddress,
        to: toAddress,
        type: Array.isArray(filterData.type)
          ? filterData.type
          : (filterData.type ? [filterData.type] : undefined),
        minBlock: filterData.blockMin ?? undefined,
        maxBlock: filterData.blockMax ?? undefined,
        dateFrom: filterData.dateFrom ?? undefined,
        dateTo: filterData.dateTo ?? undefined,
        status: Array.isArray(filterData.status)
          ? filterData.status
          : (filterData.status ? [filterData.status] : []),
      };

      this.transactionFilters = nextFilters;
      this.fetchTransactions(0);
    },
    getNftTitle(nft) {
      const title = nft.metas ? nft.metas[0] : '';
      return title ? title : '';
    },
    getCreatorName(nft) {
      const artistName = this.findItemStartingWith(nft.metadata, 'u:');
      return artistName ? artistName : '';
    },
    imageThumbnail(fileUrl) {
      const url = fileUrl;
      if (!url) return '';

      const extensionIndex = url.lastIndexOf('.');
      if (extensionIndex === -1) return url; // No extension found

      const extension = url.substring(extensionIndex);
      const baseUrl = url.substring(0, extensionIndex);
      return `${baseUrl}_thumb${extension}`;
    },
    getNftFileUrl(nft) {
      const fileUrl = nft.metas ? nft.metas[3] : '';
      return fileUrl;
    },
    findItemStartingWith(arr, keyName) {
      if (!arr || !arr.length) return null;

      for (const item of arr) {
        if (item.startsWith(keyName)) {
          return item.substring(2);
        }
      }
      return null;
    },

    getTitle() {
      return this.routeName === "transaction" ? "AppCommitHash" : "RefHash"
    },
    goBack() {
      this.$router.push({ name: 'search-result' })
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    setupTransactionData() {
      if (!this.transactionData || !this.transactionData.uat) return;
      this.transactionRefHash = this.txRefHash || this.transactionData.uat.uatData.refHash;

      this.transactionData.uat = Object.assign(this.uatOrderedSample, this.transactionData.uat);

      for (const key in this.uatDataOrderedSample) {
        this.uatDataOrderedSample[key] = this.transactionData.uat.uatData[key];
        if (key === 'userPublicKey') {
          this.uatDataOrderedSample[key] = this.transactionData.uat.uatData.pubKeyUser;
        }
      }
      this.transactionData.uat.uatData = Object.assign(this.uatDataOrderedSample)
    },
    searchByAccPublicAddress() {
      this.loaders.accountDetails = true;

      return api.getProxyNftMintAccountDetails(this.walletAddress, this.chainNumber)
        .then((res) => {
          const data = res.data;
          this.account = data;
          
          this.loaders.accountDetails = false;

      })
      .catch(() => {
        this.loaders.accountDetails = false;
      })
    },
  }
}
</script>
<style>
* {
  font-family: 'Jost-regular', sans-serif;
}

.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Inter-Regular', monospace !important;
}

.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
}

.transaction-explorer .vjs-key {
  font-family: 'Inter-Regular', monospace !important;
}
</style>
<style scoped>
.nfts__container {
  overflow-y: auto;
}

.nfts__container::-webkit-scrollbar {
  display: none;
}

.col {
  width: 30%;
}

.hash-value-col {
  width: 70%;
}

.t-results-body {
  padding: 15px 15px 10px 15px;
  border-radius: 9px 9px 9px 9px;
}

.t-results-body .row:first-child {
  border-top: unset;
}

.is-active {
  background-color: #D66339;
}

.flex__col__1 {
  max-width: 100px;
}

@media(max-width:1750px) {
  .t-results {
    gap: 20px;
  }
}

@media(max-width:1500px) {
  .overview__section {
    max-width: 570px;
  }
}

@media (max-width: 767px) {
  .main-container {
    padding: 20px 0px !important;
  }

  .overview__section,
  .nfts__section {
    width: 100%;
    margin: auto;
    max-width: 680px;
  }
}

@media (max-width: 715px) {

  .overview__section,
  .nfts__section {
    width: 100%;
    margin: auto;
    max-width: 600px;
  }

  .single-row {
    max-width: 405px;
  }
}

@media (max-width: 620px) {

  .overview__section,
  .nfts__section {
    width: 100%;
    margin: auto;
    max-width: 500px;
  }

  .single-row {
    max-width: 345px;
  }

  .nft__item>div {
    gap: 20px;
  }
}

@media (max-width: 520px) {

  .overview__section,
  .nfts__section {
    width: 100%;
    margin: auto;
    max-width: 400px;
  }

  .single-row {
    max-width: 245px;
  }
}

@media (max-width: 420px) {

  .overview__section,
  .nfts__section {
    width: 100%;
    margin: auto;
    max-width: 100%;
  }

  .single-row {
    max-width: 175px;
  }

  .nft__item>div img {
    min-width: 70px;
    max-width: 70px;
  }
}

@media (max-width: 680px) {

  .nft__item,
  .flex__col__1 {
    gap: 17px
  }
}

@media (max-width: 390px) {

  .overview__section,
  .nfts__section {
    width: 320px;

  }

  .flex__col__1 img {
    width: 50px;
  }
}
</style>
